import { axiosAdapter } from '@inertiajs/core';
import { createInertiaApp } from '@inertiajs/vue3';
import axios from 'axios';
import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers';
import moment from 'moment';
import { createApp, h } from 'vue';
import Vue3Toastify from 'vue3-toastify';
import 'vue3-toastify/dist/index.css';

window.axios = axios;
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

window.axios.interceptors.response.use(
    (response) => response,
    async (err) => {
        const status = err?.response?.status;

        // Retried once only: the replayed request goes through this interceptor again.
        if (status === 419 && !err.config.csrfRetried) {
            console.log(
                'CSRF token expired. Refreshing token and retrying request...',
            );

            await axios.get('/csrf-token');

            return axios({ ...err.config, csrfRetried: true });
        }

        return Promise.reject(err);
    },
);

window.moment = moment;

createInertiaApp({
    resolve: (name) =>
        resolvePageComponent(
            `./${name}.vue`,
            import.meta.glob('./views/**/*.vue'),
        ),
    setup({ el, App, props, plugin }) {
        const app = createApp({ render: () => h(App, props) })
            .use(plugin)
            .use(Vue3Toastify, {
                position: 'top-right',
                autoClose: 3000,
                // Toasts are often shown right before an Inertia visit: keep
                // them across URL changes (cleared by default since 0.1.10).
                clearOnUrlChange: false,
            });

        app.config.globalProperties.$active_route = (activeRoute) => {
            return activeRoute === route().current();
        };

        app.config.globalProperties.route = (name, options) =>
            route(name, options);

        app.config.globalProperties.axios = axios;

        app.mount(el);

        return { app };
    },
    // Inertia v3 ships its own HTTP client: send visits through Axios so the
    // 419 retry above still covers them.
    http: axiosAdapter(axios),
    progress: {
        color: '#4D65B9',
    },
    inject: true,
});
